<div class="site-log-edit p-3" *ngIf="customerModel">
	<div *ngIf="!customerModel.customerId" class="alert alert-info">
		Save this customer first, then return to Site Log to configure fleet assets and requirements.
	</div>

	<div *ngIf="customerModel.customerId">
		<div *ngIf="isLoading" class="text-muted">Loading site log...</div>

		<ng-container *ngIf="!isLoading && siteLogModel">
			<h5 class="mb-3">Site Log Setup</h5>
			<div class="card mb-4">
				<div class="card-header">Requirements</div>
				<div class="card-body site-log-requirements">
					<div class="site-log-requirement">
						<input class="form-check-input" type="checkbox" id="showBeforePhotos" [(ngModel)]="siteLogModel.showBeforePhotos" />
						<label class="form-check-label mb-0" for="showBeforePhotos">Before Photos</label>
					</div>
					<div class="site-log-requirement">
						<input class="form-check-input" type="checkbox" id="showAfterPhotos" [(ngModel)]="siteLogModel.showAfterPhotos" />
						<label class="form-check-label mb-0" for="showAfterPhotos">After Photos</label>
					</div>
					<div class="site-log-requirement">
						<input class="form-check-input" type="checkbox" id="showDamage" [(ngModel)]="siteLogModel.showDamage" />
						<label class="form-check-label mb-0" for="showDamage">Damage</label>
					</div>
				</div>
			</div>

			<div class="card mb-3">
				<div class="card-header">Fleet List</div>
				<div class="card-body">
					<div *ngIf="!siteLogModel.assets?.length" class="text-muted">
						No fleet assets yet. Add trucks, equipment, or other assets to track on site visits.
					</div>
					<div *ngFor="let asset of siteLogModel.assets; let i = index" class="row align-items-center mb-2">
						<div class="col-10">
							<input type="text" class="form-control" [(ngModel)]="asset.name" placeholder="e.g. Truck 1" />
						</div>
						<div class="col-2 text-center">
							<i class="bi bi-trash text-danger" style="cursor: pointer" (click)="removeAsset(i)"></i>
						</div>
					</div>
					<button type="button" class="btn btn-sm btn-outline-primary mt-2" (click)="addAsset()">
						<i class="bi bi-plus-lg"></i> Add
					</button>
				</div>
			</div>

			<button type="button" class="btn btn-outline-success" style="width: 140px;" (click)="saveSiteLog()" [slick-button-spinner]="spinnerStatus">
				<i class="bi bi-check-circle"></i> Save
			</button>

			<div class="card mt-4">
				<div class="card-header">Progress Report</div>
				<div class="card-body">
					<p class="text-muted small mb-3">
						Generate a PDF summary of fleet checklist progress for a job. Progress is tracked per job across all appointments on that job.
					</p>

					<div *ngIf="!jobItems.length" class="text-muted">
						No jobs found for this customer.
					</div>

					<ng-container *ngIf="jobItems.length">
						<div class="site-log-job-select">
							<label class="mb-1">Job</label>
							<slick-drop-down
								[items]="jobItems"
								[ngModel]="selectedJobId"
								[allowEmpty]="true"
								placeholder="Select a job..."
								(onSelect)="onJobSelected($event?.id)">
							</slick-drop-down>
						</div>

						<div *ngIf="isLoadingProgress" class="text-muted">Loading progress...</div>

						<div *ngIf="selectedJobId && !isLoadingProgress && checklistModel" class="d-flex align-items-center justify-content-between mb-3">
							<div>
								<div class="fw-semibold">{{ checklistModel.jobNumber || ('Job ' + selectedJobId) }}</div>
								<div class="text-muted small">
									{{ checklistModel.completedCount ?? 0 }} of {{ checklistModel.totalCount ?? 0 }} complete
								</div>
							</div>
							<div class="site-log-progress-ring" [style.background]="progressRingBackground" aria-label="Fleet completion progress">
								<span class="site-log-progress-ring__value">{{ progressPercent }}%</span>
							</div>
						</div>

						<button type="button"
							class="btn btn-outline-primary"
							(click)="onDownloadPdf()"
							[slick-button-spinner]="pdfSpinnerStatus"
							[disabled]="!selectedJobId || !siteLogModel.assets?.length">
							<i class="bi bi-file-pdf"></i> Download PDF
						</button>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>
</div>
